import {
    Button,
    Typography,
    ButtonProps,
    InputProps,
    OutlinedInput,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

type CustomDefaultProps = {
    label: string;
    customsx?: object;
    inputprops?: InputProps;
};

export default function UploadButton(props: ButtonProps & CustomDefaultProps) {
    const { label, customsx, inputprops } = props;
    return (
        <Button
            component="label"
            {...props}
            sx={{
                display: "flex",
                height: "3rem",
                padding: "0rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                flexShrink: 0,
                borderRadius: "1rem",
                background: "#E5EEF5",
                width: "fit-content",
                ...customsx,
                "&:hover": {
                    backgroundColor: "#fff",
                },
            }}
            variant="contained"
            startIcon={
                <AddIcon
                    sx={{
                        color: "#005499",
                        width: "20px",
                        height: "20px",
                    }}
                />
            }
        >
            <Typography
                sx={{
                    color: "#005499",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    textTransform: "none",
                }}
            >
                {label}
            </Typography>
            <OutlinedInput
                sx={{
                    clip: "rect(0 0 0 0)",
                    clipPath: "inset(50%)",
                    height: 1,
                    overflow: "hidden",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    whiteSpace: "nowrap",
                    width: 1,
                }}
                type="file"
                {...inputprops}
            />
        </Button>
    );
}
